module.exports = __webpack_public_path__ + "img/free-299.2cb6dfe5.jpg";